import { render } from "./LandingPrime.vue?vue&type=template&id=3ab13dfe&scoped=true"
import script from "./LandingPrime.vue?vue&type=script&lang=js"
export * from "./LandingPrime.vue?vue&type=script&lang=js"

import "./LandingPrime.vue?vue&type=style&index=0&id=3ab13dfe&scoped=true&lang=css"

import exportComponent from "C:\\Users\\frval\\real-gestion\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ab13dfe"]])

export default __exports__